import template from 'url-template';

import {
    FETCH_DASHBOARD_SENSOR_TYPES,
    FETCH_DASHBOARD_EQUIPMENT_TYPES,
    FETCH_EQUIPMENT_TYPES,
    FETCH_SYSTEM_TYPES
} from '../actions/actionTypes';

import { get, isEmpty } from 'lodash';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';
import { fetchAttributes } from './attributeManagementActions';

const SensorTypeUrl = template.parse('/sensor-type{?AllRecords}');
const EquipmentTypeUrl = template.parse('/equipment-type{?AllRecords}');
const AttributeLookupUrl = template.parse('/companies/{companyId}/attributes/{attributeId}/lookups');

export const createSensorType = body => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseApi.post(
            SensorTypeUrl.expand({}),
            body,
            header
        );

        dispatch(enqueueSnackbar('System Type created successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const createEquipmentType = body => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        await k2aBaseApi.post(
            EquipmentTypeUrl.expand({}),
            body,
            header
        );

        dispatch(enqueueSnackbar('Equipment Type created successfully.', 'success'));

        return true;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};

export const fetchEquipmentTypes = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    options.AllRecords = true;

    try {
        const response = await k2aBaseApi.get(
            EquipmentTypeUrl.expand({
                ...options
            }),
            header
        );

        const payload = get(response, 'data.data', []);

        dispatch({
            type: FETCH_DASHBOARD_EQUIPMENT_TYPES,
            payload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchSensorTypes = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const companyId = getState().companyInfo.companyId;

    try {
        if (isEmpty(getState().attributeManagement.attributes)) {
            await dispatch(fetchAttributes());
        }

        const attributes = getState().attributeManagement.attributes;

        const sensorTypeAttribute = attributes.find(item => item.name === 'sensorType');

        const response = await k2aBaseApi.get(
            AttributeLookupUrl.expand({
                companyId,
                attributeId: sensorTypeAttribute.id,
                ...options
            }),
            header
        );

        let formattedPayload = [];

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            formattedPayload.push({
                id:   item.id,
                name: item.value
            });
        });

        dispatch({
            type:    FETCH_DASHBOARD_SENSOR_TYPES,
            payload: formattedPayload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchEquipmentTypesLookup = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const companyId = getState().companyInfo.companyId;

    try {
        if (isEmpty(getState().attributeManagement.attributes)) {
            await dispatch(fetchAttributes());
        }

        const attributes = getState().attributeManagement.attributes;

        const equipmentTypeAttribute = attributes.find(item => item.name === 'equipmentType');

        const response = await k2aBaseApi.get(
            AttributeLookupUrl.expand({
                companyId,
                attributeId: equipmentTypeAttribute.id,
                ...options
            }),
            header
        );

        let formattedPayload = [];

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            formattedPayload.push({
                id:   item.id,
                name: item.value
            });
        });

        dispatch({
            type:    FETCH_EQUIPMENT_TYPES,
            payload: formattedPayload
        });

        dispatch({
            type:    FETCH_DASHBOARD_EQUIPMENT_TYPES,
            payload: formattedPayload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchSystemTypesLookup = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const companyId = getState().companyInfo.companyId;

    try {
        if (isEmpty(getState().attributeManagement.attributes)) {
            await dispatch(fetchAttributes());
        }

        const attributes = getState().attributeManagement.attributes;

        const systemTypeAttribute = attributes.find(item => item.name === 'systemType');

        const response = await k2aBaseApi.get(
            AttributeLookupUrl.expand({
                companyId,
                attributeId: systemTypeAttribute.id,
                ...options
            }),
            header
        );

        let formattedPayload = [];

        const payload = get(response, 'data', []);

        payload.forEach(item => {
            formattedPayload.push({
                id:   item.id,
                name: item.value
            });
        });

        dispatch({
            type:    FETCH_SYSTEM_TYPES,
            payload: formattedPayload
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const fetchExecutiveTilesLookup = (options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();

    const companyId = '00000000-0000-0000-0000-000000000000';

    try {
        if (isEmpty(getState().attributeManagement.attributes)) {
            await dispatch(fetchAttributes());
        }

        const attributes = getState().attributeManagement.attributes;

        const tilesAttribute = attributes.find(item => item.name === 'tile');

        const response = await k2aBaseApi.get(
            AttributeLookupUrl.expand({
                companyId,
                attributeId: tilesAttribute.id,
                ...options
            }),
            header
        );

        const payload = get(response, 'data', []);

        return payload;
    } catch (error) {
        dispatch(handleNetworkError(error));
        return false;
    }
};
